import { useAppSelector } from '../../redux/store';
import { selectCurrentReportId } from '../../redux/slices/reportSlice/report';
import { useParams, useSearchParams } from 'react-router-dom';

/**
 * hook to get the report id:
 * from the url
 * or from the url params
 * or from the query params
 * or from redux
 */
const useReportId = () => {
  const { reportId } = useParams();
  const [searchParams] = useSearchParams();
  const selectedReportId = useAppSelector(selectCurrentReportId);

  return reportId ?? searchParams.get('report_id') ?? selectedReportId;
};

export default useReportId;
